import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Credentials } from "../../Store/Credentials";

const ProtectedRoute = () => {
    return Credentials.isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
